module.exports = __webpack_public_path__ + "img/ooca-logo.f2c6a3c1.svg";